import Modal from 'trunks/vue/admin/components/modals/modal.js';
import WebhookModalContent from './webhook_modal_content.js';

export default Vue.extend({
  components: {
    modal: Modal,
    'webhook-modal-content': WebhookModalContent,
  },

  template: `
    <modal title="新建Webhook" ref="modal">
      <webhook-modal-content
        :webhook="webhook"
        :all-events="allEvents"
        class="modal-body"
        @valueChanged="valueChangedFunc"
      />
      <div slot='footer' class="modal-footer">
        <button class="outlined btn-default" @click='cancel'>取消</button>
        <button @click='save'>确定</button>
      </div>
    </modal>
  `,

  props: {
    webhookableId: {
      type: Number,
      required: true,
    },
    allEvents: {
      type: Array,
      required: true,
    },
    webhookablePath: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      webhook: {
        payload_url: '',
        subscribed_events: this.allEvents,
      },
    };
  },

  methods: {
    valueChangedFunc(webhook) {
      this.webhook = webhook;
    },

    cancel() {
      this.$refs.modal.close();
    },

    save() {
      Skylark.Libs.Ajax.post(`/admin/${this.webhookablePath}/${this.webhookableId}/webhooks`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: this.webhook,
        success: () => {
          this.$refs.modal.close();
          Skylark.Bridge.newAlertify('创建成功', {
            type: 'success',
          });
          this.$emit('createdSuccessed', this.webhook);
        },
        error: () => {
          Skylark.Bridge.newAlertify('操作失败，请重试', {
            type: 'error',
          });
        },
      });
    },
  },
});
